import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2Field(props) {
  var children = props.children,
      className = props.className,
      label = props.label,
      note = props.note,
      compact = props.compact,
      labelWidth = props.labelWidth,
      border = props.border,
      epic = props.epic,
      active = props.active,
      internal = props.internal,
      block = props.block,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "label", "note", "compact", "labelWidth", "border", "epic", "active", "internal", "block"]);

  var classes = classNames(className, "o2-field", labelWidth ? "o2-field--" + labelWidth + "-label" : false, {
    "o2-field--compact": compact,
    "o2-field--border": border,
    "o2-field--epic": epic,
    "o2-field--active": active,
    "o2-field--internal": internal
  });
  var labelClasses = classNames("o2-field__label", {
    "o2-field__label--block": block
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, attributes), label && /*#__PURE__*/React.createElement("div", {
    className: labelClasses
  }, label, note && /*#__PURE__*/React.createElement("div", {
    className: "o2-field__note"
  }, note)), children);
}

O2Field.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  note: PropTypes.string,
  compact: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelWidth: PropTypes.oneOf(["long", "short"]),
  border: PropTypes.bool,
  epic: PropTypes.bool,
  active: PropTypes.bool,
  internal: PropTypes.bool,
  block: PropTypes.bool
};
export default O2Field;